// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiPaper-root.model-card {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    margin: 10px;
    background-color: #1a1b27;
    color: #fff;
    cursor: pointer;
    width: 100%;
    height: max-content;
  }
  .MuiCardMedia-root.modalCardMedia {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    width: 100%;
    object-fit: cover;
    object-position: top;
    height: 250px;
  }
  .MuiCardContent-root.modalCardContent {
    text-align: start;
    background: linear-gradient(
      to bottom,
      rgba(72, 49, 157, 0.2) 20%,
      rgba(72, 49, 157, 0) 100%
    );
  }
  .MuiBox-root.modelCardHeader {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-bottom: 16px;
  }
  .MuiAvatar-root.avatarModel {
    width: 30px;
    height: 30px;
    background-color: #fff;
    margin-right: 8px;
  }
  .MuiTypography-root.modelCardTitle {
    font-size: 18px;
    font-family: var(--font-family-primary);
  }
  .MuiGrid-root.modelCardFooter {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    display: flex;
    gap: 10px;
  }
  .MuiGrid-root.modelCardFooters {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    display: flex;
    gap: 10px;
    flex-direction: row-reverse;
  }
  .MuiButtonBase-root.type-button {
    border-radius: 5px;
    text-transform: none;
    font-weight: 400;
    margin-bottom: 1px;
    background-color: #3f3589;
    color: #fff;
    font-size: 12px;
    padding: 3px 10px;
    font-family: var(--font-family-primary);
    text-transform: capitalize;
  }
  .MuiButtonBase-root.trained-button{
    border-radius: 5px;
    text-transform: none;
    font-weight: 400;
    margin-bottom: 1px;
    background-color: #40AB40;
    color: #fff;
    font-size: 12px;
    padding: 3px 10px;
    font-family: var(--font-family-primary);
    text-transform: capitalize;
  }
  .MuiTypography-root.modelCardDate {
    color: #fff;
    font-size: 12px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    margin-top: 5px;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/ModalCard/ModalCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,iBAAiB;IACjB;;;;KAIC;EACH;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,uCAAuC;EACzC;EACA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,SAAS;EACX;EACA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,uCAAuC;IACvC,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,uCAAuC;IACvC,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;EACjB","sourcesContent":[".MuiPaper-root.model-card {\n    display: flex;\n    flex-direction: column;\n    border-radius: 16px;\n    margin: 10px;\n    background-color: #1a1b27;\n    color: #fff;\n    cursor: pointer;\n    width: 100%;\n    height: max-content;\n  }\n  .MuiCardMedia-root.modalCardMedia {\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    width: 100%;\n    object-fit: cover;\n    object-position: top;\n    height: 250px;\n  }\n  .MuiCardContent-root.modalCardContent {\n    text-align: start;\n    background: linear-gradient(\n      to bottom,\n      rgba(72, 49, 157, 0.2) 20%,\n      rgba(72, 49, 157, 0) 100%\n    );\n  }\n  .MuiBox-root.modelCardHeader {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    margin-bottom: 16px;\n  }\n  .MuiAvatar-root.avatarModel {\n    width: 30px;\n    height: 30px;\n    background-color: #fff;\n    margin-right: 8px;\n  }\n  .MuiTypography-root.modelCardTitle {\n    font-size: 18px;\n    font-family: var(--font-family-primary);\n  }\n  .MuiGrid-root.modelCardFooter {\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n    display: flex;\n    gap: 10px;\n  }\n  .MuiGrid-root.modelCardFooters {\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n    display: flex;\n    gap: 10px;\n    flex-direction: row-reverse;\n  }\n  .MuiButtonBase-root.type-button {\n    border-radius: 5px;\n    text-transform: none;\n    font-weight: 400;\n    margin-bottom: 1px;\n    background-color: #3f3589;\n    color: #fff;\n    font-size: 12px;\n    padding: 3px 10px;\n    font-family: var(--font-family-primary);\n    text-transform: capitalize;\n  }\n  .MuiButtonBase-root.trained-button{\n    border-radius: 5px;\n    text-transform: none;\n    font-weight: 400;\n    margin-bottom: 1px;\n    background-color: #40AB40;\n    color: #fff;\n    font-size: 12px;\n    padding: 3px 10px;\n    font-family: var(--font-family-primary);\n    text-transform: capitalize;\n  }\n  .MuiTypography-root.modelCardDate {\n    color: #fff;\n    font-size: 12px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    margin-top: 5px;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
